import ECSEditor from 'components/editor/ECSEditor';
import ECSEditorPage from 'components/editor/ECSEditorPage';
import Toolbar from 'components/viewer/toolbars/Toolbar';
import ZoomControls from 'components/viewer/toolbars/ZoomControls';
import { FeatureFlag } from 'featureFlags';
import History from 'history';
import has from 'lodash/has';
import { getAppServices } from 'providers/app-services';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Doc } from 'records/Doc';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import DocViewerFooter from './DocViewerFooter';
import DocViewerHeader from './DocViewerHeader';

const editorContainerId = 'doc-viewer-container';

interface Params {
  docId: string;
}

interface State {
  dataLoaded: boolean;
  previousLocation: History.Location;
}

interface Props extends WithAppStoreProps, RouteComponentProps<Params> {}

class DocViewerPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    let previousLocation: History.Location = {
      pathname: `/project/${props.appState.selectedProject}/dashboard`,
      search: '',
      state: {},
      hash: '',
    };

    if (has(props.history.location.state, 'previousLocation')) {
      const s = props.history.location.state as {
        previousLocation: History.Location;
      };
      previousLocation = s.previousLocation;
    }

    this.state = {
      dataLoaded: false,
      previousLocation,
    };
  }

  async componentDidMount(): Promise<void> {
    const { appState, actions, match } = this.props;
    const { docId } = match.params;

    // fetch document, and pages associated with the document.
    // might have to do some kinda check to see if use has permission
    // to edit this particular document and pages.
    await Promise.all([
      actions.getDocument(appState.selectedProject, docId),
      actions.getPages(docId),
    ]);

    this.setState({ dataLoaded: true });
  }

  handleNavBackClick = (): void => {
    const { history } = this.props;
    const { previousLocation } = this.state;

    history.push(previousLocation);
  };

  render(): React.ReactNode {
    const {
      appState,
      match: { params },
    } = this.props;
    const { documents, pages } = appState;
    const { dataLoaded } = this.state;
    const { featureFlagService } = getAppServices();

    const doc = documents.get(params.docId, new Doc());

    const queryParams = new URLSearchParams(this.props.location.search);
    const pageIndex = parseInt(queryParams.get('page') || '0', 10);

    const page = pages
      .valueSeq()
      .filter((p) => p.documentid === doc.documentid)
      .find((p) => p.pageIndex === pageIndex);

    return dataLoaded && page ? (
      <div className="vh100 column">
        <DocViewerHeader doc={doc} onNavBackClick={this.handleNavBackClick} />
        <ECSEditor containerId={editorContainerId} isModal isScrollable>
          <ECSEditorPage key={page.pageid} doc={doc} page={page} withMarkups />
          <ZoomControls />
          {featureFlagService.hasFeature(FeatureFlag.ViewerToolbar) && (
            <Toolbar />
          )}
        </ECSEditor>
        <DocViewerFooter doc={doc} page={page} />
      </div>
    ) : null;
  }
}

export default withAppStore<Props>(DocViewerPage);
